import { render } from "./ParametrosInspecao.vue?vue&type=template&id=eccb3886&scoped=true"
import script from "./ParametrosInspecao.vue?vue&type=script&lang=js"
export * from "./ParametrosInspecao.vue?vue&type=script&lang=js"

import "./ParametrosInspecao.vue?vue&type=style&index=0&id=eccb3886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccb3886"]])

export default __exports__